module.exports = __webpack_public_path__ + "img/1695193201115-mahmudah  dapur mama abi.jpg.62cbc64a.webp";